export default __webpack_public_path__ + "static/img_8733-6857970ec3bfa3bd533acedffb2e467d.png";